import React from "react";
import { Box } from "@mantine/core";
import styles from "./surface.module.css";

interface SoftNotePanelProps {
  icon?: React.ReactNode;
  children: React.ReactNode;
  /** Optional right-aligned slot (e.g. an edit ActionIcon). */
  rightSection?: React.ReactNode;
  iconColor?: string;
}

/** Soft informational panel: icon + text on the --soft-panel fill. */
export default function SoftNotePanel({
  icon,
  children,
  rightSection,
  iconColor,
}: SoftNotePanelProps) {
  return (
    <Box className={styles.softPanel}>
      {icon && (
        <Box
          className={styles.softPanelIcon}
          style={iconColor ? { color: iconColor } : undefined}
        >
          {icon}
        </Box>
      )}
      <Box className={styles.softPanelBody}>{children}</Box>
      {rightSection}
    </Box>
  );
}
